export default "__VITE_ASSET__Ci$Zepk$__"